import React, {FC} from 'react';
import {Spinner} from 'react-bootstrap';
import {Callbacks} from 'components/TimePicker/reducer';
import {DateSlot, Location} from 'components/TimePicker/types';

import Banner from './Banner';
import LocationMap from './LocationMap';
import LocationNotes from './LocationNotes';
import LocationSlots from './LocationSlots';
import PhotosSlider from './PhotosSlider';
import SimilarPlaces from './SimilarPlaces';

import * as styles from './styles.module.scss';

interface ContentProps {
	location?: Location
	slug: string
	initial?: string
	loading: boolean
	active?: DateSlot
	callbacks: Callbacks
}

const Content: FC<ContentProps> = ({
	location,
	slug,
	initial,
	loading,
	active,
	callbacks,
}) => {
	if (!location) {
		return (
			<div className={styles.wrapper}>
				<Banner />
				<div className={styles.details}>
					<LocationNotes location={{details: {slug}}} />
					<div className={styles.loading}>
						<Spinner />
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className={styles.wrapper}>
			<Banner location={location} />
			<div className={styles.details}>
				<LocationNotes
					location={location}
					isPrivate={Boolean(
						location.details.isPrivate ||
						active?.isPrivate
					)}
				/>
				<LocationSlots
					location={location}
					initial={initial}
					loading={loading}
					callbacks={callbacks}
				/>
			</div>
			<LocationMap location={location} />
			<PhotosSlider urls={location.photos.urls} />
			<SimilarPlaces location={location} />
		</div>
	);
};

export default Content;
